"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const TabsBase = styled_components_1.default.div `
  margin-bottom: 0;
`;
const TabButton = styled_components_1.default.button.attrs((p) => ({
    className: "tab-button",
})) `
  &.tab-button {
    flex: 1 0 auto;
    margin-bottom: 0;
  }
`;
const Tabs = ({ tabItems = [] }) => {
    return ((0, jsx_runtime_1.jsx)(TabsBase, { role: "group", children: tabItems.map((t, index) => {
            const { label = "", onClick = () => { } } = t;
            return ((0, jsx_runtime_1.jsx)(TabButton, { onClick: onClick, children: label }, `TabButton:${index}`));
        }) }));
};
exports.Tabs = Tabs;
